import { render, staticRenderFns } from "./ShipmentsInquiryGrid.vue?vue&type=template&id=7e908065&"
import script from "./ShipmentsInquiryGrid.vue?vue&type=script&lang=js&"
export * from "./ShipmentsInquiryGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports